export default "assets/icon-play-outline-288e7d6d.svg";